import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";

const ACCEPT = "image/*,.heic,.heif";

export const UploadDropzone = ({ queue, max, disabled, onAdd, onRemove }) => {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);

  const take = (list) => {
    const files = Array.from(list || []).filter((f) => f.type.startsWith("image/") || /\.(heic|heif)$/i.test(f.name));
    if (files.length) onAdd(files);
  };

  return (
    <div>
      <div
        data-testid="pic-dropzone"
        onClick={() => !disabled && inputRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); if (!disabled) take(e.dataTransfer.files); }}
        style={{
          border: `2px dashed ${drag ? "#2563eb" : "#cbd5e1"}`, background: drag ? "#eff6ff" : "#f8fafc",
          borderRadius: 14, padding: "36px 20px", textAlign: "center", cursor: disabled ? "default" : "pointer",
          transition: "background-color .2s, border-color .2s",
        }}
      >
        <ImagePlus size={36} color="#2563eb" style={{ margin: "0 auto 10px" }} />
        <div style={{ fontWeight: 600, fontSize: 16 }}>Drop photos here or tap to upload</div>
        <div style={{ color: "#64748b", fontSize: 13, marginTop: 4 }}>
          Business cards, name badges, flyers or screenshots · JPG, PNG, HEIC · up to {max} at once
        </div>
        <input ref={inputRef} type="file" accept={ACCEPT} multiple hidden data-testid="pic-file-input"
          onChange={(e) => { take(e.target.files); e.target.value = ""; }} />
      </div>

      {queue.length > 0 && (
        <div data-testid="pic-queue" style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 14 }}>
          {queue.map((q) => (
            <div key={q.id} style={{ position: "relative", width: 96, height: 72, borderRadius: 8, overflow: "hidden", border: "1px solid #e2e8f0" }}>
              <img src={q.preview} alt={q.file.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              {!disabled && (
                <button type="button" data-testid={`pic-queue-remove-${q.id}`} onClick={() => onRemove(q.id)}
                  style={{ position: "absolute", top: 3, right: 3, background: "rgba(15,23,42,.75)", color: "#fff", border: 0, borderRadius: 999, width: 20, height: 20, display: "grid", placeItems: "center", cursor: "pointer" }}>
                  <X size={12} />
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
